import Alysa from "../../images/Alysa.jpeg";
import jacquelyn from "../../images/jacquelyn.jpeg";
import deborah from "../../images/deborah.jpeg";
import Natalie from "../../images/Natalie.jpeg";
import amy from "../../images/amy.jpeg";
import greg from "../../images/greg.jpeg";
import edgar from "../../images/edgar.jpeg";
import heather from "../../images/heather.jpeg";
import shamsha from "../../images/shamsa.png";
import chris from "../../images/chris.jpeg";


export const advisoryCouncilData = [
  {
    id: 1,
    imageUrl: Alysa,
    title: "Alyssa Reinhart",
    description: "Strengthen educational pathways into the workforce",
    linkedin: "https://www.linkedin.com/in/alyssareinhart/",
  },
  {
    id: 2,
    imageUrl: jacquelyn,
    title: "Jacquelyn Schulz",
    description: "Workforce Initiatives, U.S. CSG Strategic Operations at CGI",
    linkedin: "https://www.linkedin.com/in/jacquelyncraddock/",
  },
  {
    id: 3,
    imageUrl: deborah,
    title: "Deborah Kobes",
    description: "Senior Fellow, Apprenticeship and Workforce",
    linkedin: "https://www.linkedin.com/in/deborahkobes/",
  },
  {
    id: 4,
    imageUrl: Natalie,
    title: "Natalie Miller",
    description:
      "Talent Management & Development Fanatic | Relationship Developer | Sales & Marketing Leader | HR",
    linkedin: "https://linkedin.com/in/dummy-natalie",
  },
  {
    id: 5,
    imageUrl: amy,
    title: "Amy Mackenroth",
    description:
      "Shaping strategies and opportunities for future workforce growth and innovation with partners nationally.",
    linkedin: "https://linkedin.com/in/dummy-amy",
  },
  {
    id: 6,
    imageUrl: greg,
    title: "Greg Vaughn",
    description: "Executive Director, Texas Association of Workforce Board",
    linkedin: "https://linkedin.com/in/dummy-greg",
  },
  {
    id: 7,
    imageUrl: edgar,
    title: "Edgar Padilla",
    description: "Consulting Manager",
    linkedin: "https://linkedin.com/in/dummy-edgar",
  },
  {
    id: 8,
    imageUrl: heather,
    title: "Heather Terenzio",
    description:
      "Senior Executive in Workforce Development with a passion for Start-ups and Entrepreneurship",
    linkedin: "https://linkedin.com/in/dummy-heather",
  },
  {
    id: 9,
    imageUrl: shamsha,
    title: "Shamsah Noorani",
    description: "General Manager, Health Tech Academy",
    linkedin: "https://linkedin.com/in/dummy-shamsah",
  },
  {
    id: 10,
    imageUrl: chris,
    title: "Chris Lofton",
    description: "General Manager, Health Tech Academy",
    linkedin: "https://linkedin.com/in/dummy-chris",
  },

];
